import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Typography,
} from "@mui/material";
import Linkify from "linkify-react";

import Main from "../../components/layout/Main";
import MetaData from "../../components/MetaData";
import Body from "../../components/theme/Body";
import Heading from "../../components/theme/Heading";

const SEO_TITLE = "Hoe werkt het?";
const SEO_DESCRIPTION =
  "Wil je meer weten over Solidaritijd, wil je het toepassen voor jouw eigen demonstratie of heb je een andere vraag? Neem dan contact op.";
const QA = [
  {
    question: "Hoe kan ik reiskosten aanvragen?",
    answer:
      "Ga naar de pagina van een demonstratie. Klik op de knop 'Vergoeding aanvragen' en vul het formulier in. Vervolgens word je gekoppeld aan een sponsor. Na afloop van de demonstratie voeg je het bewijs van deelname toe en voer je jouw rekeningnummer in, zodat de sponsor jouw reiskosten kan overmaken.",
  },
  {
    question: "Hoe kan ik iemands reiskosten vergoeden?",
    answer:
      "Ga naar de pagina van een demonstratie. Zoek een aanvraag die je wil betalen en klik op 'Vergoeden'. Vul het formulier in. Na de demonstratie ontvang je een bewijs van deelname en het rekeningnummer waar je het bedrag naar kan overmaken.",
  },
  {
    question: "Hoe bewijs ik mijn deelname?",
    answer:
      "Na afloop van de demonstratie ontvang je een e-mail met een link. Via die link kom je bij een formulier waar je bewijs van deelname kan selecteren. Dit kan een foto van een los treinkaartje of een declaratieoverzicht van je OV-chipkaart zijn.",
  },
  {
    question: "Wat doen jullie met mijn data?",
    answer:
      "We proberen zo min mogelijk data op te slaan, maar om misbruik te voorkomen slaan we bepaalde gegevens tijdelijk op. Van de demonstrant slaan we bij aanvraag het het e-mailadres, de gebruikersnaam en het ip-adres op. Na afloop van de demonstratie slaan we het bewijs van deelname en de rekeninggegevens op. Van de sponsor slaan we de gebruikersnaam en het e-mailadres op. Binnen een maand na de demonstratie worden alle gegevens gewist.",
  },
  {
    question: "Blijf ik anoniem?",
    answer:
      "We proberen jouw gegevens zo goed mogelijk af te schermen, maar er zullen enkele persoonlijke gegevens worden uitgewisseld tussen demonstrant en sympathisant. De demonstrant deelt zijn rekeningegevens en het bewijs van deelname met de sponsor. De sponsor maakt direct geld over naar de demonstrant, waardoor ook zijn rekeninggegevens zichtbaar zijn voor de demonstrant. \n\nHelaas is het wegens technische en juridische redenen niet mogelijk om anonimiteit beter te waarborgen.",
  },
  {
    question: "Hoe maak ik een declaratieoverzicht?",
    answer:
      "Kijk voor informatie over het maken van een declaratieoverzicht voor het bevestigen van je deelname op https://www.ov-chipkaart.nl/declaratieoverzicht-maken.",
  },
  {
    question: "Wat als ik mijn reiskosten niet heb ontvangen?",
    answer:
      "Als je de reiskosten na afloop van de demonstratie niet terug hebt gekregen, neem dan contact op via https://solidaritijd.nl/contact.",
  },
];

const About = () => {
  return (
    <div>
      <MetaData description={SEO_DESCRIPTION} title={SEO_TITLE} />
      <Main>
        <Heading marginBottom="0.5em" variant="h1">
          Hoe werkt het?
        </Heading>
        <Body marginBottom="1em" maxWidth={800}>
          Solidaritijd verbindt demonstranten die de reiskosten te hoog vinden
          met sympathisanten die ze voor ze willen betalen. Lees hier meer over
          hoe dat werkt.
        </Body>
      </Main>
      <Container sx={{ marginTop: "1em" }}>
        {QA.map(({ answer, question }, index) => (
          <Accordion key={`qa-${index}`}>
            <AccordionSummary
              aria-controls={`panel${index}-content`}
              expandIcon={<ArrowDropDownIcon />}
              id={`panel${index}-header`}
            >
              <Typography component="span">{question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ whiteSpace: "preserve-breaks" }}>
                <Linkify options={{ target: "_blank" }}>{answer}</Linkify>
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </div>
  );
};

export default About;
